import { render, staticRenderFns } from "./Contact-Detail.vue?vue&type=template&id=ea6b4780"
import script from "./Contact-Detail.vue?vue&type=script&lang=js"
export * from "./Contact-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports